import theme from '@guestyci/foundation/theme/defaultTheme';

export const mediaScreen = {
  md: `@media screen and (max-width: ${theme.breakpoints.values.md}px)`,
};

const AppStyle = {
  darkLink: {
    color: '#0F265C',
    fontWeight: 600,
  },
  marketingSuccessButton: {
    background: '#00D2B5',
    borderRadius: 34,
    fontSize: '1.25rem',
    padding: '13px 50px',
    marginBottom: '14px',
    [mediaScreen.md]: {
      height: '2.5rem', // 40px
      margin: '.5rem auto',
      maxWidth: '100% !important',
      width: '100%',
    },
  },
  marketingSuccessButtonSmallHeight: {
    marginTop: '5vh',
    maxWidth: '100%',
  },
  marketingSuccessButtonClear: {
    color: '#0F265C',
    textDecoration: 'underline',
    fontSize: '1.25rem',
    fontWeight: 700,
  },
  marketingFormInput: {
    borderRadius: '6.25rem', // 100px
    fontSize: '1rem',
    borderColor: '#BDC3D0',
    height: '3.75rem', // 60px
    width: '100%',
    padding: 0,
    position: 'relative',

    '& input': {
      borderRadius: '6.25rem', // 100px
      padding: '0 15px',
    },

    '& [class*="Input-suffix"]': {
      position: 'absolute',
      right: 10,
    },

    '&:has([class*="Input-suffix"]) input': {
      paddingRight: 40,
    },

    '& input::placeholder': {
      fontSize: '1rem',
    },

    [mediaScreen.md]: {
      height: '2.5rem', // 40px
    },
  },
  marketingFormInputMobile: {
    width: '100%',
  },
  pageTextContainer: {
    marginBottom: '7vh',
  },
  pageTextContainerSmallHeight: {
    marginBottom: '4vh',
  },
  pageHeading: {
    fontSize: '3rem', // 48px
    lineHeight: 1.2,
    fontWeight: '800',
    letterSpacing: '-0.01em',
    color: '#10275B',
    [mediaScreen.md]: {
      fontSize: '1.75rem',
      lineHeight: 1.5,
    },
  },
  pageHeadingSmallHeight: {
    fontSize: '28px;',
    lineHeight: '33px',
    marginBottom: '1vh',
  },
  pageSubheading: {
    fontSize: '21px;',
    lineHeight: '30px',
    color: '#10275B',
  },
  pageSubheadingSmallHeight: {
    fontSize: '19px;',
    lineHeight: '28px',
  },
  formRow: {
    marginBottom: '2vh',
  },
  formRowMobile: {
    marginBottom: '0',
    paddingLeft: '5px',
    paddingRight: '5px',
  },
  formCol: {
    marginBottom: '0',
  },
  formColMobile: {
    marginBottom: '23px',
  },
};

export default AppStyle;
